<template>
  <v-card v-if="accounts.length > 0" flat>
    <v-data-table :headers="headers" :items="accounts" hide-default-footer>
      <template v-slot:top>
        <v-card-title>
          <v-icon>mdi-webhook</v-icon>
          <span class="headline ml-3">Config Report</span>
        </v-card-title>
        <v-divider></v-divider>
      </template>
      <template v-slot:item.telegrams="{ item }">
        <v-select
          v-model="item.telegrams"
          :items="Object.values(telegrams())"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          multiple
          :loading="itemLoading == item.id"
          @change="updateAccount(item)"
        ></v-select>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { ACCOUNT } from "@/store/actions.type";
export default {
  name: "ReportTerminals",
  props: {
    accounts: {
      type: null,
      default: null
    },
    terminals: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      token: null,
      itemLoading: null,
      overlay: false,
      headers: [
        {
          text: "Account",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Report to Telegrams", value: "telegrams" },
        { text: "Actions", value: "actions" }
      ]
    };
  },
  computed: {
    ...mapGetters(["errors", "currentUser"])
  },
  watch: {},
  methods: {
    telegrams() {
      return this.terminals.filter(terminal => terminal.type === "telegram");
    },
    updateAccount(account) {
      this.itemLoading = account.id;
      this.$store.dispatch(ACCOUNT.EDIT, account).then(() => {
        this.itemLoading = null;
      });
    }
  }
};
</script>

<style></style>
